export default __webpack_public_path__ + "static/media/char_head_prem_005.e2916a26.png";